// Causes images data
import baptismGroup from './images/baptism_group.74b5a71a.jpg';
import baptismGroupThumb from './images/baptism_group_thumb.fc65e6dd.jpg';
import baptismGroup2 from './images/baptism_group_2.3761f9cd.jpg';
import baptismGroup2Thumb from './images/baptism_group_2_thumb.ffbfa5f7.jpg';
import baptismGroup2002 from './images/baptism_group_2002.53080827.jpg';
import baptismGroup2002Thumb from './images/baptism_group_2002_thumb.8254fd8e.jpg';
import baptismLady from './images/baptism_lady.aba6e71e.jpg';
import baptismLadyThumb from './images/baptism_lady_thumb.2fad7dea.jpg';
import choirSingingRed from './images/choir_singing_red.36d7c7e6.jpg';
import choirSingingRedThumb from './images/choir_singing_red_thumb.39d7c483.jpg';
import churchExt from './images/church_ext.049841a2.jpg';
import churchExtThumb from './images/church_ext_thumb.27def3b0.jpg';
import churchExt2 from './images/church_ext_2.d883c30f.jpg';
import churchExt2Thumb from './images/church_ext_2_thumb.495850ad.jpg';
import churchExt3 from './images/church_ext_3.250e40eb.jpg';
import churchExt3Thumb from './images/church_ext_3_thumb.4eb593e9.jpg';
import churchGroup from './images/church_group.f1a61664.jpg';
import churchGroupThumb from './images/church_group_thumb.62c0da80.jpg';
import churchMainConstruction from './images/church_main_construction.4570596c.jpg';
import churchMainConstructionThumb from './images/church_main_construction_thumb.494e8e6b.jpg';
import concert from './images/concert.73a5d892.jpg';
import concertThumb from './images/concert_thumb.cc988873.jpg';
import grouLadiesWhite from './images/grou_ladies_white.e79747a6.jpg';
import grouLadiesWhiteThumb from './images/grou_ladies_white_thumb.3c4d59c5.jpg';
import kidsChoirGroup from './images/kids_choir_group.831793cb.jpg';
import kidsChoirGroupThumb from './images/kids_choir_group_thumb.ca175ca4.jpg';
import marriage from './images/marriage.5e7e1726.jpg';
import marriageThumb from './images/marriage_thumb.175861d0.jpg';
import school6Grade from './images/school_6_grade.184d265a.jpg';
import school6GradeThumb from './images/school_6_grade_thumb.c13f6134.jpg';
import schoolGraduation2013 from './images/school_graduation_2013.530406ed.jpg';
import schoolGraduation2013Thumb from './images/school_graduation_2013_thumb.d5a001cb.jpg';
import schoolStudents from './images/school_students.2bb0cdeb.jpg';
import schoolStudentsThumb from './images/school_students_thumb.730310aa.jpg';
import schoolStudents2 from './images/school_students_2.e7b1b25c.jpg';
import schoolStudents2Thumb from './images/school_students_2_thumb.901ed3c0.jpg';
import newImage1 from './images/2025-11-15-1.jpeg';
import newImage2 from './images/2025-11-15-2.jpeg';
import newImage3 from './images/2025-11-15-3.jpeg';
import newImage4 from './images/2025-11-15-4.jpeg';

export const causesImages = [
  { id: 1, thumbnail: baptismGroupThumb, src: baptismGroup, alt: 'Baptism Group' },
  { id: 2, thumbnail: baptismGroup2Thumb, src: baptismGroup2, alt: 'Baptism Group 2' },
  { id: 3, thumbnail: baptismGroup2002Thumb, src: baptismGroup2002, alt: 'Baptism Group 2002' },
  { id: 4, thumbnail: baptismLadyThumb, src: baptismLady, alt: 'Baptism Lady' },
  { id: 5, thumbnail: choirSingingRedThumb, src: choirSingingRed, alt: 'Choir Singing' },
  { id: 6, thumbnail: churchExtThumb, src: churchExt, alt: 'Church Exterior' },
  { id: 7, thumbnail: churchExt2Thumb, src: churchExt2, alt: 'Church Exterior 2' },
  { id: 8, thumbnail: churchExt3Thumb, src: churchExt3, alt: 'Church Exterior 3' },
  { id: 9, thumbnail: churchGroupThumb, src: churchGroup, alt: 'Church Group' },
  { id: 10, thumbnail: churchMainConstructionThumb, src: churchMainConstruction, alt: 'Church Construction' },
  { id: 11, thumbnail: concertThumb, src: concert, alt: 'Concert' },
  { id: 12, thumbnail: grouLadiesWhiteThumb, src: grouLadiesWhite, alt: 'Ladies Group' },
  { id: 13, thumbnail: kidsChoirGroupThumb, src: kidsChoirGroup, alt: 'Kids Choir' },
  { id: 14, thumbnail: marriageThumb, src: marriage, alt: 'Marriage Ceremony' },
  { id: 15, thumbnail: school6GradeThumb, src: school6Grade, alt: 'School 6th Grade' },
  { id: 16, thumbnail: schoolGraduation2013Thumb, src: schoolGraduation2013, alt: 'School Graduation 2013' },
  { id: 17, thumbnail: schoolStudentsThumb, src: schoolStudents, alt: 'School Students' },
  { id: 18, thumbnail: schoolStudents2Thumb, src: schoolStudents2, alt: 'School Students 2' },
  { id: 19, thumbnail: newImage1, src: newImage1, alt: 'EUCA Church 2025' },
  { id: 20, thumbnail: newImage2, src: newImage2, alt: 'EUCA Church 2025' },
  { id: 21, thumbnail: newImage3, src: newImage3, alt: 'EUCA Church 2025' },
  { id: 22, thumbnail: newImage4, src: newImage4, alt: 'EUCA Church 2025' }
];
